// extracted by mini-css-extract-plugin
export var button = "_fy-4";
export var hasDarkBackground = "_fy-7";
export var hasLightBackground = "_fy-6";
export var iconWrapper = "_fy-0";
export var large = "_fy-2";
export var medium = "_fy-1";
export var small = "_fy-5";
export var xsmall = "_fy-3";